import type { ReactNode } from 'react';

import { ToastContainer } from './ToastContainer';

export function ToastProvider({ children }: { children: ReactNode }) {
  return (
    <>
      {children}
      <ToastContainer />
    </>
  );
}
